import { IAuctionState, IAuctionStrategy } from './types';

export const defaultStrategy: IAuctionStrategy = {
  isEnabled: false,
  serviceTypes: [],
  strategyName: '',
};

export const defaultState: IAuctionState = {
  isEnabled: false,
  isOpen: false,
  currentBet: 0,
  prevBet: 0,
  minimalBet: 0,
  maximalBet: 0,
  configurations: {},
  services: [],
  incompatibleServices: [],
  periods: [],
  serviceCosts: [],
  strategy: defaultStrategy,
};
